import { Colors } from '..';

export const themeSpecificColors = {
  core01_10: '#EFE7F2', // corresponds to core01 with alpha=0.1 over a white background
  core01_20: '#DED0E6',
  core01_60: '#9D71B3',
  core02_20: '#DED0E6',
  core02_80: '#6E4E8B',
  core03_10: '#EBE8ED',
  core04: '#D2548E',
  core04_40: '#EE99CC',
  core05: '#28A1C6',
  core06: '#D4007F',
  limbo01: '#1872BB',
  table_cell_highlight: '#F5F5F5',
  // the original neutral03 colour failed accessibility contrast requirements, so a slightly darker one was requested in some places
  neutral03_darker: '#757575',
};

export const colors: Colors = {
  core01: '#5C1380',
  core02: '#4A226E',
  core03: '#38174F',
  core04: '#FFFFFF', // JL Theme required
  core05: '#FFFFFF', // JL Theme required
  core06: '#FFFFFF', // JL Theme required
  neutral01: '#333333',
  neutral02: '#4D4B4C',
  neutral03: '#847F82',
  neutral04: '#C4C0C2',
  neutral05: '#D1D1D1',
  neutral06: '#EDEDED',
  neutral07: '#F5F5F5', // not required as per RSA designs (neutral-07 exists in the style guide, but is used in different places)
  neutral08: '#FFFFFF',
  cardBorder: '#DED0E6',
  cardIcon: '#5C1280',
  navigationHighlight: '#D4007F',
  notificationError: '#CC2929',
  notificationErrorDark: '#9A0A0C',
  notificationErrorLight: '#FAEAEA',
  notificationWarning: '#D17A00',
  notificationWarningLight: '#FBE7B2',
  notificationSuccess: '#0C8400',
  notificationSuccessLight: '#EBF6EB',
  notificationInfo: '#1872BB',
  notificationInfoLight: '#F3F8FB',
  selectorHighlight: '#6B0656',
  selectorHighlightWithTransparency: '#6B0656',
};
